import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { AuthWrapped } from '~/modules/navigation/components'
import { ReprintPage } from '~/modules/reprint/view'
import { PATH } from '~/AppRoutes'

export const ReprintRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('REPRINT_LABELS')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={ReprintPage} canAccess={canAccess} />} />
    </Routes>
  )
}

export const reprintLinks = {
  reprintLink: () => PATH.OVERVIEW,
}
